/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Description_ColInputs */

const en_admin_categories_description_col = /** @type {(inputs: Admin_Categories_Description_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_admin_categories_description_col = /** @type {(inputs: Admin_Categories_Description_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Admin_Categories_Description_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_description_col = /** @type {((inputs?: Admin_Categories_Description_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Description_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_description_col(inputs)
	return zh_admin_categories_description_col(inputs)
});
export { admin_categories_description_col as "admin.categories.description_col" }